module.exports = __webpack_public_path__ + "static/media/washer-light-gray.a922b49f.svg";